import script from "./PianificazioneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PianificazioneDialog.vue?vue&type=script&setup=true&lang=js"

import "./PianificazioneDialog.vue?vue&type=style&index=0&id=b623141a&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b623141a"]])

export default __exports__